export default {
  pricing: {
    title: "Preise",
    hero: {
      title: "Ein Abo. Voller Zugriff.",
      subtitle: "Starte kostenlos. Schalte das volle Erlebnis auf Web und Mobile frei.",
      newsletterTitle: "1 year of Linemate+ for $45",
      newsletterSubtitle: "Your discount code is automatically applied at checkout, so just choose the annual plan and you’re good to go.",
      newsletterPriceLine: "44,99 US$ für das ganze Jahr",
      newsletterRenewLine: "Verlängert sich für 59,99 US$/Jahr",
    },
    plans: {
      free: {
        features: [
          "Tägliche Trend-Plays",
          "Trefferquoten für Teams und Spieler",
          "Gamelogs und Leistungsverlauf",
        ],
      },
      annual: {
        billingShort: "Jahr",
        billingLong: "jährlich",
        features: [
          "Enthält alles aus dem kostenlosen Plan +",
          "Jedes Play-Signal und vollständige Analyse",
          "Startaufstellungen, Verletzungseinflüsse und Wetter",
          "Exklusiver Zugriff auf jede Kombiwette",
          "Tiefere Einblicke in alle Trend-Kombiwetten",
          "Erweiterte Suchfilter",
          "Option zur Auswahl und Änderung der Quotenansicht",
        ],
      },
      monthly: {
        billingShort: "Monat",
        billingLong: "monatlich",
        features: [
          "Enthält alles aus dem kostenlosen Plan +",
          "Jedes Play-Signal und vollständige Analyse",
          "Startaufstellungen, Verletzungseinflüsse und Wetter",
          "Exklusiver Zugriff auf jede Kombiwette",
          "Tiefere Einblicke in alle Trend-Kombiwetten",
          "Erweiterte Suchfilter",
          "Option zur Auswahl und Änderung der Quotenansicht",
        ],
      },
    },
    actions: {
      currentPlan: "Dein aktueller Plan",
      manage: "Verwalten",
      upgrade: "Upgraden",
    },
    badges: {
      mostPopular: "Am beliebtesten",
      annualSavings: "Spare bis zu 60% mit dem Jahresplan",
    },
    operators: {
      prefix: "Vollständig integriert mit",
      highlight: "globalen Anbietern",
      suffix: "für ein reibungsloses Erlebnis von Recherche bis Wette",
    },
    sections: {
      fullPicture: "Sieh das ganze Bild, bevor du wettest",
      signals: "Schalte alle Signale für besseren Kontext frei",
    },
    testimonials: {
      trusted: "Vertraut von<br/>900k Sportwettern",
      betslips: "Über<br/>1M+ erstellte Betslips",
      previous: "Vorherige Testimonials",
      next: "Nächste Testimonials",
      items: [
        {
          title: "Wirklich die am besten designte App, die ich seit Langem gesehen habe.",
          description: "Alles ist genau dort, wo es sein muss, jede Auswahl funktioniert wie erwartet, und die App ist sehr durchdacht gestaltet. Sie ist voller Informationen, bleibt aber effizient und gut organisiert. Als Stats-Nerd ziehe ich den Hut vor Linemate für das App-Design und dafür, wie leicht man gute Plays findet.",
        },
        {
          title: "Beste App von allen",
          description: "Das ist zu 100% die beste App für Sportwetten. Nachdem ich sie ein paar Tage getestet hatte, war ich überzeugt. Ich empfehle die kostenpflichtige Version sehr, damit du alles nutzen kannst, was die App bietet. Du wirst nicht enttäuscht sein.",
        },
        {
          title: "Die beste",
          description: "Ich habe viele Stats-Apps ausprobiert. Linemate ist die, zu der ich immer zurückkomme. Sie bieten kostenlos am meisten, fügen ständig Features hinzu, ohne etwas wegzunehmen, und der Plus-Plan ist den Preis wirklich wert. Der Support hat in 5 Minuten geantwortet. Man merkt, dass sie die Go-to-App sein wollen.",
        },
        {
          title: "Positiv überrascht",
          description: "Wenn du neu bist und Props blind folgst, werden die Ergebnisse schwanken; du brauchst trotzdem Strategie. Ich habe Linemate heruntergeladen, nachdem meine Parlays immer knapp danebenlagen, und mein erster 7-Leg-Player-Prop-Parlay hat getroffen. Mit der kostenlosen ersten Woche ist der monatliche Preis leicht gerechtfertigt.",
        },
        {
          title: "Tolle App!",
          description: "Keine Wett-App ist jemals perfekt, aber diese hat mir bisher die besten Ergebnisse geliefert. Alles basiert auf echten Stats und Daten. Die kostenlose Version ist solide, und das Abo ist noch besser.",
        },
        {
          title: "Eine App, die heraussticht",
          description: "Eine großartige App, die wirklich heraussticht, bezahlbar ist und starke Recherche-Features bietet. Insgesamt tolle Arbeit.",
        },
      ],
    },
    comparison: {
      premium: "Jährlich/Monatlich",
      included: "Enthalten",
      notIncluded: "Nicht enthalten",
    },
    popup: {
      billedAnnually: "Jährlich abgerechnet",
      savePercent: "{{percent}}% sparen",
      upgradeForJust: "Upgrade für nur {{price}}/{{billingPeriod}}",
      dismiss: "Schließen",
    },
  },
};
